import { UseMutateAsyncFunction, useMutation } from 'react-query';

import { getAPIErrorMessage } from '../../../utils/ApiErrorUtils';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

function useVerifySignUpWithPhoneOTP(): {
  verifySignUpWithPhoneOTPAPI: UseMutateAsyncFunction<
    any,
    unknown,
    {
      phoneNumber: string;
      countryCode: string;
      clientId: string;
      otpValue: string;
      acceptedTandC: boolean | null;
      customId?: string;
    },
    unknown
  >;
  error: string;
  status;
} {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const verifySignUpWithPhoneOTP = (params) => {
    const {
      phoneNumber,
      countryCode,
      clientId,
      otpValue,
      acceptedTandC,
      customId
    } = params;

    return ibUserAccountsAPIService.verifyRegistrationOfPhoneNumber({
      phone_number: phoneNumber,
      country_code: countryCode,
      client_id: clientId,
      otp_value: otpValue,
      accepted_tnc: acceptedTandC,
      custom_id: customId
    });
  };

  const { mutateAsync, error, status } = useMutation(verifySignUpWithPhoneOTP);

  const verifySignUpWithPhoneOTPAPI = mutateAsync;

  return {
    verifySignUpWithPhoneOTPAPI,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
}

export { useVerifySignUpWithPhoneOTP };
